// eslint-disable-next-line import/no-cycle
import Instance from './require';

const config = {
  baseURL: 'https://crm.256devs.com/api/',
  endpoints: {
    login_user: 'login',
    get_priorities: 'priorities',
    get_job_categories: 'jobCategories',
    get_qualifications: 'qualifications',
    project_need: 'projectsNeed',
    lead: 'lead',
    funnel_type: 'funnelTypes',
    funnel_status: 'funnelStatuses',
    work_type: 'workTypes',
    work_tech: 'workTechnologies',
    responsible: 'leadResponsible',
    upworkAccount: 'upworkAccount',
    proposalTypes: 'proposalTypes',
    upworkAdditional: 'upworkAdditional',
    leadFirstMessage: 'leadFirstMessage',
    eventTypes: 'eventTypes',
    eventPlans: 'eventPlans',
    leadFile: 'leadFile',
    leadFolder: 'leadFolder',
    comment: 'comment',
    gotanswer: 'lead/gotanswer',
    rawdone: 'lead/rawdone',
    finedone: 'lead/finedone',
    deal: 'lead/deal',
    notqualified: 'lead/notqualified',
    checkByJob: 'lead/checkByJob',
  },
};

const http = Instance(config);

const api = {
  async get(what, params) {
    const url = config.endpoints[what];
    if (params) {
      return http.get(url, { params });
    }
    return http.get(url);
  },
  async getByQuery(what, params) {
    const url = config.endpoints[what];
    return http.get(`${url}${params}`);
  },
  async post(what, data, id) {
    let url;
    if (!!id || id === 0) {
      url = `${config.endpoints[what]}/${id}`;
    } else {
      url = `${config.endpoints[what]}`;
    }
    return http.post(url, data);
  },
  async put(what, id, data) {
    let url;
    if (id !== '') {
      url = `${config.endpoints[what]}/${id}`;
    } else {
      url = `${config.endpoints[what]}`;
    }
    return http.put(url, data);
  },
  async delete(what, id, data) {
    const url = `${config.endpoints[what]}/${id}`;
    return http.delete(url, data);
  },
};

export default api;
export { config };
